// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/helpers/VisualEditorComponentContainer.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/helpers/VisualEditorComponentContainer.tsx");
  import.meta.hot.lastModified = "1717182690457.4048";
}
// REMIX HMR END

import { openVisualEditorComponent } from "drupal-visual-editor";
export default function VisualEditorComponentContainer({
  action,
  storage,
  uuid,
  children
}) {
  return (
    // eslint-disable-next-line
    <section id={`${storage}-${uuid}`} data-visual-editor-component={`${storage}-${uuid}`} onClick={() => openVisualEditorComponent({
      action,
      storage,
      uuid
    })}>
      {children}
    </section>
  );
}
_c = VisualEditorComponentContainer;
var _c;
$RefreshReg$(_c, "VisualEditorComponentContainer");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;